import getDetails from "./get-details";

export default function getDetail(...options) {
  return getDetails(...options)[0];
}
